import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const EventsIcon = ({
  color = 'foraBlue',
  width = 17,
  marginLeft,
  marginRight,
  containerSize,
  title,
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    width={width}
    title={title}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 15">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M2.49 7.583c.561 0 1.022.475 1.022 1.069v.055c0 .97.77 1.761 1.724 1.757l5.935-.023c.902-.005 1.636-.72 1.704-1.621l.011-.285c.056-.537.493-.952 1.016-.952h2.505v4.693c0 1.014-.802 1.84-1.798 1.84H1.797C.802 14.116 0 13.29 0 12.276V7.583zM11.625.891c.61 0 1.177.298 1.536.793l.084.129 2.966 4.88h-2.309c-1.013 0-1.838.805-1.908 1.82l-.005.17c0 .48-.371.864-.823.866l-5.934.024c-.453.001-.829-.383-.829-.866v-.055L4.4 8.513c-.07-1.015-.895-1.82-1.91-1.82H.196l2.966-4.88c.32-.529.868-.867 1.469-.916L4.78.891h6.844z"
      />
    </svg>
  </DefaultIconWrapper>
);
